import * as ng from 'angular';

export const PropsFilterObjects: ng.FilterFactory = ($filter: ng.IFilterService) => {
    return (items, props) => {
        let out = [];
        if (ng.isArray(items)) {
            let keys = Object.keys(props);
            items.forEach((item) => {
                let itemMatches = false;
                for (let i = 0; i < keys.length; i++) {
                    let prop = keys[i];
                    let text = props[prop].toLowerCase();
                    if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                        itemMatches = true;
                        break;
                    }
                }

                if (itemMatches) {
                    out.push(item);
                }
            });
        } else {
            // let the output be the input untouched
            out = items;
        }
        return out;
    };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/filters/props-filter-objects.filter.ts